module.exports = __webpack_public_path__ + "img/PICT0015.80ded59f.jpg";